import { Head, useForm } from "@inertiajs/react";

import Layout from "/AdminLayout";
import { useToast } from "/utils/toast-context.jsx";
import CollectionForm from "/components/Admin/CollectionForm";

const EditCollection = ({
  collection,
}) => {
  const { data, setData, put, transform, errors } = useForm({ ...collection });
  const { successToast, errorToast } = useToast();

  const handleSubmit = (state, preview = false) => {
    transform((data) => ({
      ...data,
      state: state,
      preview: preview,
    }));
    put(
      `/admin/collections/${collection.id}`,
      {
        preserveScroll: true,
        onSuccess: () => successToast("Сохранено"),
      }
    );
  };

  return (
    <>
      <Head>
        <title>Новая коллекция</title>
      </Head>

      <CollectionForm
        data={data}
        setData={setData}
        onSubmit={handleSubmit}
        errors={errors}
      />
    </>
  );
}

EditCollection.layout = (page) => <Layout children={page} />;

export default EditCollection;
